module.exports = __webpack_public_path__ + "static/img/swiper_next.582e3d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mo/swiper_next.png
// module id = 9qgd
// module chunks = 0